import "./BudgetForm.scss"
import { useEffect, useState } from "react"
import IconPicker from "../../components/IconPicker"
import BudgetAmountInput from "./BudgetAmountInput"

interface Props {
    budget: Budget
    onDelete?: () => void
    onUpdate?: (params: BudgetParams) => void
}

const BudgetForm = (props: Props) => {

    const { budget, onDelete = () => {}, onUpdate = () => {}} = props

    const [amountCents, setAmountCents] = useState(budget.amount_cents)
    const [name, setName] = useState(budget.name)

    const [color, setColor] = useState(budget.color)
    const [icon, setIcon] = useState(budget.icon)

    const [confirmDelete, setConfirmDelete] = useState(false)

    useEffect(() => setName(budget.name), [budget.name])
    useEffect(() => setAmountCents(budget.amount_cents), [budget.amount_cents])
    useEffect(() => setColor(budget.color), [budget.color])
    useEffect(() => setIcon(budget.icon), [budget.icon])


    useEffect(() => {
        save()
    }, [amountCents])
    
    const save = () => onUpdate({name, amount_cents: amountCents})
    const changed = name !== budget.name || amountCents !== budget.amount_cents
    const saveChanges = () => changed ? save() : null

    const onUpdateIconAndColor = (params: {icon: string, color: string}) => {
        setIcon(params.icon)
        setColor(params.color)
        onUpdate(params)
    }
     
    const style = {
        backgroundColor: color
    }
    return <div className="budget-form" style={style}>
        <div className='container'>
            <div className='icon-picker-container'>
                <IconPicker icon={icon} color={color} update={onUpdateIconAndColor}/>
            </div>
            <input
                className="input-name"
                value={name}
                onChange={(e) => setName(e.target.value)}
                onBlur={() => saveChanges()}/>
            <BudgetAmountInput
                value={amountCents}
                onChange={setAmountCents}/>

            <div className="delete-button-container">
                
                { !confirmDelete && <div className="delete-button fa fa-trash-can" onClick={() => setConfirmDelete(true)}/>}
                { confirmDelete && <div className='delete-confirm'>
                    <div className='message'>Supprimer ?</div>
                    <div className='button' onClick={() => onDelete()}>Oui</div>
                    <div className='button' onClick={() => setConfirmDelete(false)}>Non</div>
                </div>}
            </div>
        </div>
    </div>
}

export default BudgetForm
